import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-tourist-guides-history',
	templateUrl: './tourist-guides-history.component.html',
	styleUrls: ['./tourist-guides-history.component.css'],
})
export class TouristGuidesHistoryComponent implements OnInit {
	id: string;

	constructor(private readonly route: ActivatedRoute) {}

	ngOnInit(): void {
		if (!this.route.snapshot.params['id']) {
			return;
		}
		this.id = this.route.snapshot.params['id'];
	}
}
